import { useApi } from '@backstage/core-plugin-api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { customAlertApiRef } from '@agilelab/plugin-wb-platform';
import { notificationApiRef } from '../notificationApiRef';
import { WEBHOOKS_KEY } from './reactQuery';

export const useCreateWebhook = () => {
  const notificationApi = useApi(notificationApiRef);
  const alertApi = useApi(customAlertApiRef);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: any) => notificationApi.createWebhook(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [WEBHOOKS_KEY] });
      alertApi.post({
        severity: 'success',
        message: 'Webhook created successfully',
      });
    },
    onError: e => {
      alertApi.post({
        severity: 'error',
        message: (e instanceof Error ? e : new Error('Something went wrong'))
          .message,
      });
    },
  });
};
